import { render, staticRenderFns } from "./CandidateMenu.vue?vue&type=template&id=2fe6746d&scoped=true&"
import script from "./CandidateMenu.vue?vue&type=script&lang=ts&"
export * from "./CandidateMenu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe6746d",
  null
  
)

export default component.exports